import React from "react";
import { useNavigate } from "react-router-dom";

import { Tooltip } from "antd";
import { FaInfoCircle } from "react-icons/fa";
import dayjs from "dayjs";

import "./styles.scss"
import uris from "../../../../config/uris";

const PlanAlert = ({ hideSideBar, planDetails }) => {

    const navigate = useNavigate()

    const alertTextFormatter = () => {
        if (planDetails?.endDate) {
            const currentDate = dayjs();
            const endDate = dayjs(planDetails.endDate);

            const planIdentifier = planDetails?.planName === "Trial" ? "Trial" : "Plan";
            const expiryStatusText = endDate.isAfter(currentDate) ? "Ends" : "Ended"

            return `${planIdentifier} ${expiryStatusText} on:`
        }
    }

    const handleRedirect = ({ url }) => {
        navigate(url)
    }

    return (
        <div className="plan-alert-section" onClick={() => { handleRedirect({ url: uris?.paymentHistory }) }}>
            {hideSideBar ? (
                <>
                    <Tooltip
                        title={
                            <div style={{ color: "#7b6631", cursor: "pointer" }}><div className="title">Plan ends on: {dayjs(planDetails?.endDate).format("DD-MMM") || ""}</div></div>
                        }
                        color="#FFFFFF"
                        className="tooltip-text"
                        placement="right"
                    >
                        <FaInfoCircle className="trial-expiry-icon" />
                    </Tooltip>
                </>
            ) : (
                <>
                    <FaInfoCircle className="trial-expiry-icon" />
                    <div className="title">{alertTextFormatter()} {dayjs(planDetails?.endDate).format("DD-MMM") || ""}</div>
                </>
            )}
        </div>
    )
}

export default PlanAlert